export default "__VITE_PUBLIC_ASSET__69fb401c__"